export var RelatedCompanyType;
(function (RelatedCompanyType) {
    RelatedCompanyType["Employer"] = "EMPLOYER";
    RelatedCompanyType["SelfEmploymentBusiness"] = "SELF_EMPLOYMENT_BUSINESS";
})(RelatedCompanyType || (RelatedCompanyType = {}));
//# sourceMappingURL=RelatedCompany.js.map